<template>
	<div>
		<div class="lg:flex">
			<div class="lg:w-1/2 flex"></div>
			<div class="lg:w-1/2 flex justify-end">
				<ButtonBlack>
					<router-link :to="'/admin/listado/noticias-categorias'" class="text-white no-underline">
						<div class="flex items-center">
							<span>{{ $t('categorias') }}</span>
						</div>
					</router-link>
				</ButtonBlack>
				<ButtonBlack>
					<router-link :to="'/admin/' + section" class="text-white no-underline">
						<div class="flex items-center">
							<img src="@/assets/img/nuevo-mas.svg" alt="Nuevo" />
							<span>{{ $t('new') }}</span>
						</div>
					</router-link>
				</ButtonBlack>
			</div>
		</div>
		<ListTable :itemsTitles="itemsTitles" :items="news" :section="section" :itemsTable="itemsTable" />
	</div>
</template>

<script>
import ListTable from '@/components/ListTable'
import gql from 'graphql-tag'

export default {
	apollo: {
		news: {
			query: gql`
				{
					news(order_by: { publishing_date: desc }) {
						id
						title
						country {
							code
						}
						news_category {
							category_name
						}
						featured
						publishing_date
						active
					}
				}
			`,
			update(data) {
				return data.news.map(item => ({
					id: item.id,
					title: item.title,
					countryCode: item.country.code,
					category: item.news_category.category_name,
					featured: item.featured ? 'Si' : 'No',
					date: this.$moment(item.publishing_date).format('DD-MM-YYYY'),
					edit: true,
					active: item.active,
				}))
			},
		},
	},
	data() {
		return {
			section: 'noticias',
			itemsTable: 'news',
			itemsTitles: ['Id', 'title', 'Pais', 'category', 'featured', 'date'],
		}
	},
	components: { ListTable },
}
</script>

<style>
td {
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
}
</style>
